module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Sākums")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v("Piegādes adreses")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui segment",
    class: {
      loading: _vm.storeStatus.loading
    }
  }, [(_vm.legalAddressError) ? _c('div', {
    staticClass: "ui warning icon message"
  }, [_c('i', {
    staticClass: "warning circle icon"
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('table', {
    staticClass: "ui selectable table orange"
  }, [(!_vm.checkClientWidth) ? _c('thead', [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.full_address))]), _vm._v(" "), (item.is_legal_address == 1 && !_vm.checkClientWidth) ? _c('td', [_vm._v("Jā")]) : (!_vm.checkClientWidth) ? _c('td', [_vm._v("Nē")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.notes))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "ui custom_brown button",
      on: {
        "click": function($event) {
          return _vm.goToEditPage(item)
        }
      }
    }, [_vm._v("Rediģēt")]), _vm._v(" "), (_vm.items.length > 1) ? _c('button', {
      staticClass: "ui custom_brown icon button",
      on: {
        "click": function($event) {
          return _vm.initDeleteAddress(item)
        }
      }
    }, [_c('i', {
      staticClass: "right trash icon"
    })]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('router-link', {
    staticClass: "ui right floated green button",
    attrs: {
      "to": {
        name: 'user-address-add'
      }
    }
  }, [_c('i', {
    staticClass: "icon plus"
  }), _vm._v("Pievienot adresi")]), _vm._v(" "), _c('div', {
    staticClass: "ui clearing hidden divider"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "user-address-delete-dialog"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "ui custom_brown ok inverted button",
    on: {
      "click": _vm.deleteAddress
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n        Jā\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n      Pirms dzēsiet šo adresi, sākumā izvēlieties citu juridisko adresi!\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Adrese")]), _vm._v(" "), _c('th', [_vm._v("Juridiskā adrese")]), _vm._v(" "), _c('th', [_vm._v("Tālrunis kurjeram")]), _vm._v(" "), _c('th', [_vm._v("Norādes kurjeram")]), _vm._v(" "), _c('th', [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon header"
  }, [_c('i', {
    staticClass: "trash icon"
  }), _vm._v("\n      Vai dzēst ierakstu?\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui grey basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n        Nē\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07bd934e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserAddressPage.vue
// module id = 318
// module chunks = 1